function formatPrice(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  if (typeof cents !== 'number') cents = parseInt(cents);
  var dollars = (cents / 100).toFixed(2);
  var body = document.body;
  var symbol = body ? body.getAttribute('data-currency-symbol') || '$' : '$';
  return symbol + dollars;
}

function openCartDrawer() {
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartOverlay');
  if (!drawer) return;
  drawer.classList.add('cart-drawer--open');
  if (overlay) overlay.classList.add('cart-overlay--show');
  document.body.style.overflow = 'hidden';
  renderCartDrawer();
}

function closeCartDrawer() {
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartOverlay');
  if (!drawer) return;
  drawer.classList.remove('cart-drawer--open');
  if (overlay) overlay.classList.remove('cart-overlay--show');
  document.body.style.overflow = '';
}

function renderCartDrawer() {
  var loaderEl = document.getElementById('cartDrawerLoader');
  var itemsEl = document.getElementById('cartDrawerItems');
  if (loaderEl) loaderEl.style.display = '';
  if (itemsEl) itemsEl.style.display = 'none';
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (loaderEl) loaderEl.style.display = 'none';
      var emptyEl = document.getElementById('cartDrawerEmpty');
      var footerEl = document.getElementById('cartDrawerFooter');
      var countEl = document.getElementById('cartDrawerCount');
      var subtotalEl = document.getElementById('cartDrawerSubtotal');
      if (countEl) countEl.textContent = cart.item_count;
      if (subtotalEl) subtotalEl.textContent = formatPrice(cart.total_price);

      if (cart.item_count === 0) {
        if (itemsEl) itemsEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = '';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }
      if (itemsEl) itemsEl.style.display = '';
      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = '';

      if (!itemsEl) return;
      itemsEl.innerHTML = '';
      cart.items.forEach(function(item, i) {
        var div = document.createElement('div');
        div.className = 'cart-drawer__item';
        div.style.setProperty('--item-delay', (i * 0.06) + 's');
        div.innerHTML =
          '<div class="cart-drawer__item-img-wrap">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" class="cart-drawer__item-img" loading="lazy">' : '<div class="cart-drawer__item-placeholder"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg></div>') +
          '</div>' +
          '<div class="cart-drawer__item-info">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
            '<div class="cart-drawer__item-meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
            '<div class="cart-drawer__item-bottom">' +
              '<div class="cart-drawer__item-qty">' +
                '<button class="cart-drawer__qty-btn" data-qty-down data-key="' + item.key + '">' +
                  '<svg width="10" height="2" viewBox="0 0 10 2" fill="currentColor"><rect width="10" height="2" rx="1"/></svg>' +
                '</button>' +
                '<span class="cart-drawer__qty-num">' + item.quantity + '</span>' +
                '<button class="cart-drawer__qty-btn" data-qty-up data-key="' + item.key + '">' +
                  '<svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor"><rect x="4" width="2" height="10" rx="1"/><rect y="4" width="10" height="2" rx="1"/></svg>' +
                '</button>' +
              '</div>' +
              '<span class="cart-drawer__item-price">' + formatPrice(item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="cart-drawer__item-remove" data-remove data-key="' + item.key + '" aria-label="Remove ' + item.product_title.replace(/"/g, '&quot;') + '">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>';
        itemsEl.appendChild(div);
      });

      itemsEl.querySelectorAll('[data-qty-up]').forEach(function(b) {
        b.addEventListener('click', function() { updateCartItem(this.getAttribute('data-key'), 1); });
      });
      itemsEl.querySelectorAll('[data-qty-down]').forEach(function(b) {
        b.addEventListener('click', function() { updateCartItem(this.getAttribute('data-key'), -1); });
      });
      itemsEl.querySelectorAll('[data-remove]').forEach(function(b) {
        b.addEventListener('click', function() { updateCartItem(this.getAttribute('data-key'), -999); });
      });

      var checkoutBtn = document.getElementById('cartDrawerCheckout');
      if (checkoutBtn) {
        checkoutBtn.onclick = function() { window.location.href = '/checkout'; };
      }
    })
    .catch(function() {});
}

function updateCartItem(key, delta) {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (!item) { renderCartDrawer(); return; }
      var newQty = item.quantity + delta;
      if (newQty < 1) newQty = 0;
      var updates = {};
      updates[key] = newQty;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(r) { if (r) return r.json(); })
    .then(function() {
      if (typeof updateCartCount === 'function') updateCartCount();
      renderCartDrawer();
    })
    .catch(function() {});
}

var revealObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

document.querySelectorAll('.reveal-fade, .reveal').forEach(function(el) {
  revealObserver.observe(el);
});

(function initParallax() {
  var banners = document.querySelectorAll('.ib');
  if (!banners.length) return;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      banners.forEach(function(b) {
        var rect = b.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = 1 - (rect.top + rect.height * 0.3) / (vh + rect.height * 0.6);
        var img = b.querySelector('.ib__image');
        if (img) {
          var offset = Math.max(-8, Math.min(8, (progress - 0.5) * -12));
          img.style.transform = 'scale(1.03) translateY(' + offset + 'px)';
        }
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

document.addEventListener('DOMContentLoaded', function() {
  var closeBtn = document.getElementById('cartDrawerClose');
  var overlay = document.getElementById('cartOverlay');
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  var cartLink = document.querySelector('[data-cart-link]');
  if (cartLink) {
    cartLink.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  var closeBtnToast = document.getElementById('cartToastClose');
  var toast = document.getElementById('cartToast');
  if (closeBtnToast && toast) {
    closeBtnToast.addEventListener('click', function() {
      toast.classList.remove('cart-toast--show');
      toast.classList.add('cart-toast--hide');
      clearTimeout(toast._hideTimer);
    });
  }


});

function showCartToast(productTitle, productImg) {
  var toast = document.getElementById('cartToast');
  var productEl = document.getElementById('cartToastProduct');
  var imgEl = document.getElementById('cartToastImg');
  var thumbEl = document.getElementById('cartToastThumb');
  var progressEl = document.getElementById('cartToastProgress');
  if (!toast) return;
  if (productEl) productEl.textContent = productTitle;
  if (imgEl && productImg) {
    imgEl.src = productImg;
    if (thumbEl) thumbEl.style.display = '';
  } else if (thumbEl) {
    thumbEl.style.display = 'none';
  }
  toast.classList.remove('cart-toast--hide');
  toast.classList.add('cart-toast--show');
  clearTimeout(toast._hideTimer);
  if (progressEl) {
    progressEl.style.animation = 'none';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        progressEl.style.animation = 'toastProgress 3.5s linear forwards';
      });
    });
  }
  toast._hideTimer = setTimeout(function() {
    toast.classList.remove('cart-toast--show');
    toast.classList.add('cart-toast--hide');
  }, 3600);
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.classList.remove('header__cart-count--pulse');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            badge.classList.add('header__cart-count--pulse');
          });
        });
      }
    })
    .catch(function() {});
}


